import { alertConstants } from "../constants/alert.constants";

export function alert(state = {}, action) {
  switch (action.type) {
    case alertConstants.SUCCESS:
      return {
        color: "green",
        message: action.message,
      };
    case alertConstants.INFO:
      return {
        color: "blue",
        message: action.message,
      };
    case alertConstants.ERROR:
      return {
        color: "red",
        message: action.message,
      };
    case alertConstants.CLEAR:
      return {};
    default:
      return state;
  }
}
